import constants from 'helpers/constants';

function createSource (data) {
  const date = new Date();
  date.setFullYear(date.getFullYear() - 1);

  const sourceDef = constants.data.lookup('sourceTypes', data?.type);

  return [{
    name: data.name,
    nextRun: date.toISOString(),
    params: {
      collectionId: null,
      publicCollectionId: null,
      query: data.query,
      link: data.link,
      fileEnrichProfiles: false,
      fileOverwriteValues: false,
      fileStaticDataset: false,
      ...data.params
    },
    period: data.period ?? sourceDef?.period,
    subType: data.subType,
    type: data.type,
    comment: data.comment,
  }];
}

const source = {
  createSource,
}

export default source;
